export default class AuditSections {
  static ALL_CATEGORIZED = "allCategorized";

  static NO_PAYEE = "noPayee";

  static NO_CLASS = "noClass";

  static NO_LOCATION = "noLocation";

  static NO_PROJECT = "noProject";

  static NO_ATTACHMENT = "noAttachment";

  static AMOUNT_DEVIATION = "amountDeviation";

  static DUPLICATES = "duplicates";

  static SIMILAR_PAYEE = "similarPayee";

  static POSTED_TO_PARENT = "postedToParent";

  static UNUSUAL_CATEGORY = "unusualCategory";

  static UNUSUAL_AMOUNT = "unusualAmount";

  static UNUSUAL_TAX = "unusualTax";
}
